import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { getImageQueries } from "store/services/ImageQueries/imageQueriesThunks";
import { ListResponse } from "types/api";
import { ImageQuery } from "types/imageQueries";

interface ImageQueriesState {
  data: ListResponse<ImageQuery>;
  page: number;
  pageSize: number;
  loading: boolean;
  error: string | null;
}

const initialState: ImageQueriesState = {
  data: {
    count: 0,
    next: null,
    previous: null,
    results: [],
  },
  page: 1,
  pageSize: 50,
  loading: false,
  error: null,
};

const imageQueriesSlice = createSlice({
  name: "imageQueries",
  initialState,
  reducers: {
    setPage: (state, action: PayloadAction<number>) => {
      state.page = action.payload;
    },
    setPageSize: (state, action: PayloadAction<number>) => {
      state.page = 1;
      state.pageSize = action.payload;
    },
    handleResetImageQueries: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getImageQueries.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getImageQueries.fulfilled, (state, action: PayloadAction<ListResponse<ImageQuery>>) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getImageQueries.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch api tokens";
      });
  },
});

export const { setPage, setPageSize, handleResetImageQueries } = imageQueriesSlice.actions;

export default imageQueriesSlice;
